
import { defineComponent } from 'vue';

import {
  CREATIVE_APPROVAL_STATUS_PENDING_APPROVAL,
  CREATIVE_APPROVAL_STATUS_APPROVED,
  CREATIVE_APPROVAL_STATUS_DECLINED,
} from '@/libs/consts';

import useCreativeActions from '@/composable/useCreativeActions';

export default defineComponent({
  props: {
    creativeId: {
      type: Number,
      required: true,
    },
    creativeApprovalStatus: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const {
      approvingCreativeId,
      changeApprovalStatus,
    } = useCreativeActions();

    const onSuccess = (newStatus: number): void => {
      emit('update:creativeApprovalStatus', newStatus);
    };

    return {
      CREATIVE_APPROVAL_STATUS_PENDING_APPROVAL,
      CREATIVE_APPROVAL_STATUS_APPROVED,
      CREATIVE_APPROVAL_STATUS_DECLINED,
      approvingCreativeId,
      changeApprovalStatus,
      onSuccess,
    };
  },
});
